exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.selected[data-v-7daa6920]{color:#000}.m-0[data-v-7daa6920]{margin:0}.mr-2[data-v-7daa6920]{margin-right:.5rem}.my-35[data-v-7daa6920]{margin:35px 0}.disabled[data-v-7daa6920]{pointer-events:none;opacity:.3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7daa6920","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/SelectStoricDropdown.vue
// module id = gP+C
// module chunks = 1